<template>
  <div class="share-select">
    <ul>
      <li class="border-1px" v-for="item in dataList" @click="toShare(item)">
        <span>{{item.dishName}}</span>
        <span class="iconfont icon-right right-icon"></span>
      </li>
    </ul>
  </div>
</template>
<script>
  import {Toast} from 'mint-ui';
  import ajax from '../../pub/utils/ajaxUtils.js';
  import {getDishPot, getPrivateShareInfo} from './config/api.js';
  import mainUtils from '../../pub/utils/mainUtils';

  export default {
    name: "share-select",
    data() {
      return {
        tableBillId: '',
        memberId: '',
        dataList: [],
        potCode: '',
      }
    },
    methods: {
      // 扫描二维码获取私人订制锅底信息
      getDishPot() {
        let params = {
          tableBillId: this.tableBillId,// 账单ID
          // tableBillId: '3EBE707E711D2A1D00050569F49DE000',// 账单ID
        };
        ajax.postJson(getDishPot, params,
          data => {
            if (data.result === 200) {
              data.obj.map(d => {
                d.time = this.timeChangeYMDHM(d.orderTime);
              })
              this.dataList = data.obj;
              if (this.dataList.length === 0) {
                Toast({
                  message: '暂未发现数据',
                  position: 'top',
                  duration: 1500
                });
              }
              else {
                this.dataList.map(d => {
                  if (d.dishName.includes('火锅')) {
                    d.dishName = d.dishName.replace('火锅',"");
                  }
                });
              }
            }
          }
        );
      },
      // 通过potCode获取memberId && tableBillId
      getPrivateShareInfo() {
        let params = {
          potCode: this.potCode
        };
        ajax.postJson(getPrivateShareInfo, params,
          data => {
            if (data.result === 200) {
              this.tableBillId = data.obj.tableBillId;
              this.memberId = data.obj.memberId;
              this.getDishPot();
            }
          }
        )
      },
      toShare(item) {
        this.$set(item, 'memberId', this.memberId);
        sessionStorage.setItem('p', JSON.stringify(item));
        // this.$router.push({path: '/share', query: {dishDetailId: item.id}});
        this.$router.push({path: '/editor'});
      },
      timeChangeYMDHM(time) {
        if(!time) return '';
        let str = "";
        let t = new Date(time);
        str += t.getFullYear()  + ".";
        str += a(t.getMonth() +1)  + ".";
        str += a(t.getDate()) + " ";
        str += a(t.getHours()) + ":";
        str += a(t.getMinutes());
        function a(t){
          if(t > 9 ){
            return t;
          }else{
            return "0" + t
          }
        }
        return str ;
      }
    },
    created() {
      sessionStorage.setItem('isIOS', '1');
      let pathName = mainUtils.pathName('shareReload');
      for (let i in pathName) {
        this[i] = pathName[i];
      }
      this.potCode === '' ? this.getDishPot() : this.getPrivateShareInfo();
    }
  }
</script>
<style lang="stylus">
  @import '../../assets/css/func.styl'
  body
    height: 100%
  .share-select
    box-sizing border-box
    height: 100%
    padding: .2rem;
    font-size: .36rem;
    color: #3f3f3f;
    background: #f7f7f7;
    ul
      padding: .36rem 0
      border-radius: 0.03rem
      background: #fff
      box-shadow: 0 1px 1px rgba(21, 21, 21, 0.2);
    li
      padding-left: 0.3rem
      padding-right: 0.5rem
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
      line-height: 1.04rem
      border-x(#fff, 0, 2px)
      background: #f7f7f7
      .right-icon
        position: absolute
        right: .34rem
        color: #9a9a9a
</style>


// WEBPACK FOOTER //
// src/components/share/share-select.vue